import React from 'react'
import Layout from '../Shared/Layout/Layout';

export default ({ children }) => {
  return (
    <div>
      <Layout>
        {children}
      </Layout>
    </div>
  )
}
